<div [formGroup]="form" class="scan-extra-headers">
  <app-common-checkbox
    [(ngModel)]="modifyHandlePopups"
    (ngModelChange)="onModifyHandlePopups($event)"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="disabled"
  >
    <span class="checkbox-label">{{ 'close_popups_label' | translate }}</span>
  </app-common-checkbox>
  @if (modifyHandlePopups) {
    <div class="row margin-left">
      <div class="col">
        <div class="row margin-bottom">
          <div class="col margin-left">
            <div class="alert alert-info margin-right" id="close-popup-description">
              {{ 'close_popups_description' | translate }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col margin-left">
            <app-common-input
              id="close-popup-selector"
              [form]="form"
              [formValidationRequest$]="formValidationRequest$"
              [context]="{
                id: popupsControlName,
                field: popupsControlName,
                required: true,
                label: 'close_popup_button_selector',
                describedby: 'close-popup-description',
              }"
            >
            </app-common-input>
          </div>
        </div>
      </div>
    </div>
  }
</div>
